<template>
  <v-container text-center>
    <h1>Info</h1>
    <p>version: {{ versionNum }}</p>
    <v-btn
      color="info"
      :style="{ color: this.getConfigItem('INFO_COLOUR_TEXT') }"
      @click="$root.backToHome()"
      >{{ this.getConfigItem("BTN_HOME_TEXT") }}</v-btn
    >
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters([
      "isConfigLoaded",
      // "isShowLoadingMessage",
      // "getConfigItemNestedObjectValue",
      "getConfigItem",
    ]),
    versionNum() {
      return process.env.VUE_APP_VERSION;
    },
  },
};
</script>
